export class QuestionBase<T> {
    // value: T|undefined;
    value: any;
    key: string;
    label: string;
    required: boolean;
    disabled: boolean;
    model: boolean
    lowerCase: boolean
    order: number;
    controlType: string;
    type: string;
    hint: string;
    ngClass: string;
    optionsLink: string;
    childLink: string;
    child: string;
    validators: Array<Object>;
    asyncValidators: {key: string, value: Object}[];
    options: {key: string, value: string}[];
    modelInfo: {key: string, link: string};
    errors: {key: string, value: string}[];
    minDate: Date;
    maxDate: Date;
  
    constructor(options: {
        // value?: T;
        value?: any;
        key?: string;
        label?: string;
        required?: boolean;
        model?: boolean;
        lowerCase?: boolean;
        disabled?: boolean;
        order?: number;
        controlType?: string;
        type?: string;
        hint?: string;
        minDate?: Date;
        maxDate?: Date;
        ngClass?: string;
        optionsLink?: string;
        childLink?: string;
        child?: string;
        validators?: Array<Object>;
        asyncValidators?: {key: string, value: Object}[];
        options?: {key: string, value: string}[];
        errors?: {key: string, value: string}[];
        modelInfo?: {key: string, link: string};
      } = {}) {
      this.value = options.value;
      this.key = options.key || '';
      this.label = options.label || '';
      this.required = !!options.required;
      this.disabled = !!options.disabled;
      this.model= !!options.model;
      this.lowerCase= !!options.lowerCase;
      this.order = options.order === undefined ? 1 : options.order;
      this.controlType = options.controlType || '';
      this.type = options.type || '';
      this.hint = options.hint || '';
      this.optionsLink = options.optionsLink || '';
      this.childLink = options.childLink || '';
      this.child = options.child || '';
      this.ngClass = options.ngClass || 'col-md-6';
      this.validators = options.validators || [];
      this.asyncValidators = options.asyncValidators || [];
      this.options = options.options || [];
      this.errors = options.errors || [];
      this.modelInfo = options.modelInfo || {key: '', link: ''};
      this.minDate = options.minDate || undefined;
      this.maxDate = options.maxDate || undefined;
    }
  }
